import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import ruLocale from 'date-fns/locale/ru';
import { CircularProgress, IconButton } from '@material-ui/core';
import { Clear, Event } from '@material-ui/icons';
import classnames from 'classnames';
var stringFormat = 'HH:mm';

var formatValue = function formatValue(value) {
  var formattedValue = !value ? null : parse(String(value), stringFormat, new Date());

  if (!isValid(formattedValue)) {
    formattedValue = null;
  }

  return formattedValue;
};

function TimeField(props) {
  var _classnames;

  var id = props.id,
      required = props.required,
      field = props.field,
      value = props.value,
      error = props.error,
      onFieldChange = props.onFieldChange,
      classes = props.classes,
      slim = props.slim,
      labelWidth = props.labelWidth,
      inputLabelRef = props.inputLabelRef,
      disabled = props.disabled;
  var formattedValue = formatValue(value);

  var _useState = useState(formattedValue),
      _useState2 = _slicedToArray(_useState, 2),
      componentValue = _useState2[0],
      setComponentValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      componentError = _useState4[0],
      setComponentError = _useState4[1];

  var ID = id || field.name;
  useEffect(function () {
    setComponentValue(formatValue(value));
  }, [value]);
  /**
   * Изменение в поле ввода
   * @param time
   */

  var onChange = function onChange(time) {
    // Если дата валидная или строка ввода пустая, то показываем дефолтную ошибку
    if (isValid(time) || time === null) {
      setComponentError('');
    }

    setComponentValue(time);
  };
  /**
   * Потеря фокуса
   */


  var onBlur = function onBlur() {
    if (isValid(componentValue) && !componentError) {
      // Если дата валидная и нет ошибок, то сохраняем дату в текстовом формате
      onFieldChange(ID, format(componentValue, stringFormat));
    } else if (componentValue === null && formattedValue !== null) {
      // Если поле ввода пустое и есть дефолтная дата, то сохраняем пустую дату
      onFieldChange(ID, '');
    } else {
      // в остальных случаях возвращаем дефолтную дату и дефолтную ошибку
      setComponentValue(formattedValue);
      setComponentError('');
    }
  };
  /**
   * Выбор времени в модалке или очистка поля из модалки
   * @param time
   */


  var onAccept = function onAccept(time) {
    onFieldChange(ID, time === null ? '' : format(time, stringFormat));
  };
  /**
   * Очистка поля из календаря
   */


  var onClear = function onClear() {
    onFieldChange(ID, '');
  };
  /**
   * Устанавка сообщения об ошибке от компонента
   * @param errorMessage
   */


  var onError = function onError(errorMessage) {
    setComponentError(errorMessage);
  };

  return React.createElement(React.Fragment, null, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils,
    locale: ruLocale
  }, React.createElement(KeyboardTimePicker, {
    fullWidth: true,
    label: field.label,
    id: ID,
    name: field.name,
    variant: 'inline',
    required: !!required,
    onChange: onChange,
    onAccept: onAccept,
    onError: onError,
    value: componentValue,
    format: stringFormat,
    mask: value ? '__:__' : '',
    error: !!componentError || !!error,
    helperText: componentError || error,
    invalidDateMessage: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0432\u0440\u0435\u043C\u0435\u043D\u0438",
    minDateMessage: "\u0412\u0440\u0435\u043C\u044F \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u0430\u0442\u044B",
    maxDateMessage: "\u0412\u0440\u0435\u043C\u044F \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u0430\u0442\u044B",
    inputVariant: 'outlined',
    disabled: disabled,
    InputProps: {
      labelWidth: labelWidth,
      onBlur: onBlur,
      classes: {
        disabled: classes.disabledInput,
        input: slim ? classes.slimOutlinedInput : classes.baseOutlinedInput,
        root: slim ? classes.slimOutlinedInputRoot : classes.baseOutlinedInputRoot,
        notchedOutline: classes.notchedOutline
      }
    },
    InputLabelProps: {
      ref: inputLabelRef,
      classes: {
        root: classnames(classes.label, labelWidth ? classnames(classes.clippedLabel, classes.clippedLabelWithAdornment) : '', slim ? classes.slimOutlinedLabel : classes.baseOutlinedLabel),
        shrink: classes.shrinkLabel
      }
    },
    ampm: false,
    autoOk: true,
    PopoverProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    },
    KeyboardButtonProps: {
      size: slim ? 'small' : 'medium'
    },
    keyboardIcon: React.createElement(Event, {
      fontSize: slim ? 'small' : 'default'
    })
  })), componentValue && React.createElement(IconButton, {
    className: classnames(classes.clearButton, classes.dateClearButton, (_classnames = {}, _defineProperty(_classnames, classes.clearButtonSlim, slim), _defineProperty(_classnames, classes.dateClearButtonSlim, slim), _classnames)),
    size: slim ? 'small' : 'medium',
    "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
    onClick: onClear
  }, React.createElement(Clear, {
    fontSize: slim ? 'small' : 'default'
  })));
}

var Time = function Time(props) {
  var classes = props.classes,
      validation = props.validation,
      slim = props.slim;
  return React.createElement("div", {
    className: classes.fieldContainer
  }, React.createElement(TimeField, Object.assign({}, props)), validation && React.createElement("div", {
    className: classes.fieldLoaderContainer
  }, React.createElement(CircularProgress, {
    className: classnames(classes.fieldLoader, _defineProperty({}, classes.slimFieldLoader, !!slim)),
    size: slim ? 16 : 24,
    thickness: 4
  })));
};

export default Time;